export default Object.freeze({
    CurrentlyPage: 'CurrentlyPage',
    NewPage: 'NewPage',
    MainPage: 'MainPage',
});
